import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  FormHelperText,
  Box,
  Chip,
} from "@mui/material";

const CustomSelect = ({
  label,
  value,
  onChange,
  options,
  labelId,
  id,
  required,
  error,
  helperText,
  formControlProps,
  renderOption,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && open && !props.multiple) {
      setOpen(false);
    }
  };

  const handleChange = (event) => {
    onChange(event);
    if (!props.multiple) {
      setOpen(false);
    }
  };

  const defaultRenderValue = (selected) => {
    if (props.multiple) {
      return (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
          {selected.map((selectedValue) => {
            const option = options.find((opt) => opt.value === selectedValue);
            return (
              <Chip
                color="info"
                key={selectedValue}
                label={option ? option.label : selectedValue}
              />
            );
          })}
        </Box>
      );
    }
    const option = options.find((opt) => opt.value === selected);
    return option ? option.label : selected;
  };

  return (
    <FormControl
      fullWidth
      required={required}
      error={error}
      {...formControlProps}
      size={props.size}
      // sx={{
      //   width: "150px",
      // }}
      // size="small"
    >
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        // size="small"
        labelId={labelId}
        id={id}
        value={value}
        label={label}
        onChange={handleChange}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        onKeyDown={handleKeyDown}
        renderValue={props.renderValue || defaultRenderValue}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          getContentAnchorEl: null,
          ...props.MenuProps,
        }}
        {...props}
      >
        {options.length > 0 ? (
          options.map((option) => (
            <MenuItem
              value={option.value}
              key={option.key || option.value}
              sx={
                !renderOption
                  ? {
                      gap: 2,
                      display: "flex",
                      justifyContent: "space-between",
                      ...option.sx,
                    }
                  : option.sx
              }
            >
              {renderOption ? (
                renderOption(option, value)
              ) : (
                <>
                  <Typography variant="button">{option.label}</Typography>
                  {option.secondaryLabel && (
                    <Typography>{option.secondaryLabel}</Typography>
                  )}
                </>
              )}
            </MenuItem>
          ))
        ) : (
          <MenuItem value="" disabled>
            <Typography variant="button">No options available</Typography>
          </MenuItem>
        )}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default CustomSelect;
